import { render, staticRenderFns } from "./MailObject.vue?vue&type=template&id=7d85f52c&scoped=true&"
import script from "./MailObject.vue?vue&type=script&lang=js&"
export * from "./MailObject.vue?vue&type=script&lang=js&"
import style0 from "./MailObject.vue?vue&type=style&index=0&id=7d85f52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85f52c",
  null
  
)

export default component.exports